<template>
  <div class="page-container">
    <md-app
      md-mode="fixed">
      <md-app-toolbar md-elevation="1">
        <div class="md-toolbar-row fixed__toolbar">
          <div class="md-toolbar-section-start">
            <ScenarioHeader
              :scenario-id="parseInt($route.params.scenarioId)"
              :scenario-state="scenarioDetails.scenario_state"/>
          </div>
          <div class="md-toolbar-section-end">
            <md-button
              class="md-icon-button  md-raised  md-primary"
              @click="menuVisible = !menuVisible">
              <md-icon>menu</md-icon>
            </md-button>
          </div>
        </div>
      </md-app-toolbar>
      <md-app-content class="page-content">
        <md-button
          class="md-fab md-primary md-fab-top-right md-mini download-button"
          @click='downloadXLSXResult()'>
          <md-tooltip md-direction="left">Télécharger en xlsx</md-tooltip>
          <md-icon>cloud_download</md-icon>
        </md-button>
        <div class="box">
          <md-table
            class="overflow table-center"
            md-card
            v-model="scenarioActions">
            <md-table-toolbar>
              <h1 class="md-title">Actions incluses</h1>
            </md-table-toolbar>
            <md-table-empty-state
              md-label="Aucune action définie"
              md-description="Votre simulation ne contient aucune action" />
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }">
              <md-table-cell
                md-label="Nom"
              >
                <div class="name-cell">{{ item.name }}</div>
              </md-table-cell>
              <md-table-cell md-label="Action">
                <div class="action-cell">
                  <strong>{{ item.action_label }}</strong>
                  <div><em>{{ item.category_label }}</em></div>
                </div>
              </md-table-cell>
              <md-table-cell md-label="Total demandé">
                <strong>{{ item.rhythms_total }} {{ item.action_place_type }}</strong>
              </md-table-cell>
              <md-table-cell md-label="Total général">
                {{ item.actions['global_total'] }}
              </md-table-cell>
              <md-table-cell
                v-for="(cpt, year) in item.actions"
                :key="year"
                :md-label="year !=='global_total' ? year: 'Total général'">
                <span v-if="cpt"><strong> {{ cpt }}<md-tooltip md-direction="top">{{ placesLabel(item, year) }}</md-tooltip></strong></span>
                <span v-else> - </span>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
        <div class="box">
          <md-table
            class="overflow table-center"
            md-card
            v-model="scenarioPPIActions">
            <md-table-toolbar>
              <h1 class="md-title">Résultat de la prise en compte de la PPI et atypiques</h1>
            </md-table-toolbar>
            <md-table-empty-state
              md-label="Aucune action définie"
              md-description="Votre simulation ne contient aucune action PPI ou atypiques." />
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }">
              <md-table-cell md-label="Action">
                <div class="action-cell">
                  <strong>{{ item.label }}</strong>
                  <div><em>{{ item.category_label }}</em></div>
                </div>
              </md-table-cell>
              <md-table-cell md-label="Total général">
                {{ item.actions['global_total'] }} {{ item.action_place_type }}
              </md-table-cell>
              <md-table-cell
                v-for="(cpt, year) in item.actions"
                :key="year"
                :md-label="year !=='global_total' ? year: 'Total général'">
                <span v-if="cpt"><strong> {{ cpt }}<md-tooltip md-direction="top">{{ placesLabel(item, year) }}</md-tooltip></strong></span>
                <span v-else> - </span>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </md-app-content>
      <md-app-drawer
        :md-active.sync="menuVisible"
        class="filters">
        <template>
          <div>
            <div class="filters-title page-title">Filtres</div>
            <div
              class="alert alert-info alert-filters">
              <div class="">
                <strong>Note :</strong> Les filtres s'appliquent sur les lieux (Site, Bâtiment ou Zone) en fonction du niveau d'application des actions du scénario.
              </div>
            </div>

            <md-field>
              <label>Filtrer par nom de lieu</label>
              <md-input v-model="displayFilters.siteName" />
            </md-field>
            <md-field>
              <label for="geoplace">Filtrer par localité</label>
              <md-select
                v-model="displayFilters.selectedGeoPlace"
                name="geoplace"
                id="geoplace">
                <md-option
                  v-for='geoPlace in geoPlaceList'
                  :key='geoPlace.geonameid'
                  :value='geoPlace.geonameid'>{{ geoPlace.name }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <md-table
            class="md-content"
            v-model="functionsList"
            :md-selected-value="displayFilters.selectedFunctions"
            @md-selected="onFunctionsSelect">
            <md-table-toolbar>
              <div class="filters-title">Fonctions</div>
            </md-table-toolbar>

            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              md-selectable="multiple"
              md-auto-select>
              <md-table-cell
                md-label="Fonction">{{ item.label }}</md-table-cell>
              <md-table-cell
                md-label="Sites">{{ item.places_count }}</md-table-cell>
            </md-table-row>
          </md-table>
          <md-table
            v-model="tagsList"
            :md-selected-value="displayFilters.selectedTags"
            @md-selected="onTagsSelect">
            <md-table-toolbar>
              <div class="filters-title">Tags</div>
            </md-table-toolbar>

            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              md-selectable="multiple"
              md-auto-select>
              <md-table-cell
                md-label="Tag">{{ item.name }}</md-table-cell>
              <md-table-cell
                md-label="Sites">{{ item.places_count }}</md-table-cell>
            </md-table-row>
          </md-table>
        </template>
      </md-app-drawer>
    </md-app>
  </div>
</template>
<script>
import session from '../api/session'
import FileDownload from 'js-file-download'
import axios from 'axios'
import ScenarioHeader from '../components/ScenarioHeader.vue'
var _ = require('lodash')

export default {
  name: 'ScenarioRefine',
  components: {
    ScenarioHeader
  },
  data () {
    return {
      scenarioActions: [],
      scenarioPPIActions: [],
      actionsList: [],
      scenarioDetails: {scenario_state: 'new'},
      functionsList: [],
      tagsList: [],
      geoPlaceList: [],
      placesName: null,
      menuVisible: false,
      displayFilters: {
        siteName: '',
        selectedFunctions: [],
        selectedTags: [],
        selectedGeoPlace: null
      }
    }
  },
  created: function () {
    this.debouncedData = _.debounce(this.loadData, 300)
  },
  mounted: function () {
    this.$store.dispatch('routing/update_title', 'Programme')
    this.$store.dispatch('routing/update_return_kwargs', null)
    this.loadApi()
  },
  computed: {

  },
  methods: {
    placesLabel (item, year) {
      return item.places[year].join(', ')
    },
    onFunctionsSelect (items) {
      this.displayFilters.selectedFunctions = items
    },
    onTagsSelect (items) {
      this.displayFilters.selectedTags = items
    },
    buildQueryParams () {
      var app = this
      var queryParams = {}

      if (app.displayFilters.siteName.length > 0) {
        queryParams.name = app.displayFilters.siteName
      }

      if (app.displayFilters.selectedFunctions.length !== app.functionsList.length) {
        queryParams.functions = app.displayFilters.selectedFunctions.map(func => func.id)
      }

      if (app.displayFilters.selectedTags.length !== app.tagsList.length) {
        queryParams.tags = app.displayFilters.selectedTags.map(tag => tag.id)
      }

      if (app.displayFilters.selectedGeoPlace) {
        queryParams.geonameid = app.displayFilters.selectedGeoPlace
      }
      return queryParams
    },
    loadData: function () {
      var app = this
      var scenarioId = app.$route.params.scenarioId

      var queryParams = app.buildQueryParams()

      session.get(`/api/scenario/refine/${scenarioId}/program/`, { params: queryParams }).then(function (scenarioActionsResponse) {
        app.scenarioActions = scenarioActionsResponse.data
      })

      session.get(`/api/scenario/refine/${scenarioId}/ppi_program/`, { params: queryParams }).then(function (scenarioActionsPPIResponse) {
        app.scenarioPPIActions = scenarioActionsPPIResponse.data
      })
    },
    loadApi: function () {
      var app = this
      var scenarioId = this.$route.params.scenarioId
      let scenarioDetailsRequest = session.get(`/api/scenario/${scenarioId}/`)
      let geoPlaceRequest = session.get(`/api/scenario/${scenarioId}/geo_places/`)
      let functionsRequest = session.get(`/api/scenario/${scenarioId}/functions/`)
      let tagsRequest = session.get(`/api/scenario/${scenarioId}/tags/`)
      let actionsRequest = session.get(`/api/scenario/refine/${scenarioId}/actions/`)

      app.$store.dispatch('loading/begin_loading')

      axios.all([scenarioDetailsRequest, functionsRequest, actionsRequest, tagsRequest, geoPlaceRequest])
        .then(axios.spread(function (scenarioDetailsResponse, functionResponse, actionsResponse, tagsResponse, geoPlaceResponse) {
          app.scenarioDetails = scenarioDetailsResponse.data
          app.geoPlaceList = geoPlaceResponse.data
          app.actionsList = actionsResponse.data

          if (app.scenarioDetails.generating) {
            app.$router.push({name: 'Scenarios list'})
          }

          /*
            ugly workaround for a bug in vue-material
            https://github.com/vuematerial/vue-material/issues/1904
          */
          setTimeout(async () => {
            app.$set(app, 'functionsList', functionResponse.data)
            await app.$nextTick()
            app.displayFilters.selectedFunctions = app.functionsList

            app.$set(app, 'tagsList', tagsResponse.data)
            await app.$nextTick()
            app.displayFilters.selectedTags = app.tagsList
          }, 300)

          app.$store.dispatch('routing/update_title', app.scenarioDetails.label)

          app.geoPlaceList.unshift({'geonameid': '', 'name': 'Toutes les localités'})

          for (var i in app.functionsList) {
            app.displayFilters.selectedFunctions.push(app.functionsList[i]['id'])
          }
          app.$store.dispatch('loading/end_loading')
        }))
    },
    downloadXLSXResult () {
      var app = this
      var scenarioId = this.$route.params.scenarioId
      var queryParams = app.buildQueryParams()
      app.$store.dispatch('loading/begin_loading')
      session.get(`/api/scenario/refine/${scenarioId}/xlsx_result/`, { params: queryParams, responseType: 'arraybuffer' }).then(function (response) {
        var filename = ''
        var disposition = response.request.getResponseHeader('Content-Disposition')
        if (disposition && disposition.indexOf('attachment') !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          var matches = filenameRegex.exec(disposition)
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '')
          }
        }
        FileDownload(response.data, filename, response.headers['content-type'])
      }).then(function (response) {
        app.$store.dispatch('loading/end_loading')
      })
    }
  },
  watch: {
    displayFilters: {
      handler (val) {
        this.debouncedData()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../stylesheets/variables";

.page-content {
  overflow: auto;
  height: calc(100vh - 64*2px);
}

.filters{
  width: 400px;
  padding-left: 20px;
  padding-right: 20px;
  right: 0 !important;
  left: unset;
  top: 64px;
  transform: translate3D(100%,0,0);
  &.md-drawer.md-active{
    transform: translate3D(0%,0,0);
  }

  padding-left: 20px;

  .filters-field{
    padding: 0 16px;
  }
}

.filters-title {
    font-weight: bold;
    font-size: 18px;
    color: #86ad19;
    padding-top:0;
    padding-bottom:0;
    margin-bottom: -20px;

    &.simple-card-title{
      padding: 1em;
    }

    &.page-title{
      margin-bottom: 0px;
      margin-top: 20px;
    }
}

.box {
  padding: 20px;
  background-color: project-theme('background');
  zoom: 1;
}

.overflow {
  overflow-x: scroll !important;
}
.name-cell{
  width: 150px;
}
.action-cell{
  width: 250px;
}

.md-table-cell{
  text-align: center;
}
.download-button{
  margin-top:  50px;
  margin-bottom: 50px;
}

.alert-filters{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/ScenarioProgram.vue